import React ,{useEffect,useState} from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Button, Modal, UncontrolledTooltip } from "reactstrap";

export  const EventResponseDialog=(props)=> {
  
  const {handleClose, handleSave, value } = props;  
  console.log('EventResponseDialog message: ', value)
  const [open, Setopen] = useState(true)
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const closeOpen=(e)=>{
    e.preventDefault();
    props.closeUserView();
    Setopen(false);
  }
  let updResponse =['', 'Signed Deal','Work in Progress',"No Deal","No Answer Yet","Already in Business","" , "", "Not Seen"];
  return (
    <div>
      <Modal size="xs" style={{ maxWidth:"700px" }} className="modal-dialog-centered" isOpen={open}>
          

            {value?.overallList == null  &&
              <><div className="modal-header">
              <strong>{ value?.title }</strong> 
              <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={ closeOpen}>
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div style = {{ marginLeft:"25px"}}>{ value?.message }</div>
    
            <div className="modal-footer">
            <Button color="success" type="button" onClick={()=>handleSave(value, 1)}>Approve</Button>
            <Button color="warning" type="button" onClick={()=>handleSave(value, 0)}>Still Under Discussion</Button>
            <Button color="warning" type="button" onClick={()=>handleSave(value, 2)}>No Deal</Button>
            <Button color="success" type="button" onClick={()=>handleSave(value, 5)}>Already Connected</Button>
            {/* <Button color="secondary" data-dismiss="modal" type="button"  onClick={closeOpen}>Close</Button> */}
            </div></>
            }
            {value?.overallList  && value?.overallList.length == 1 &&
                          <><div className="modal-header">
                          <strong>{ value?.title }</strong> 
                          <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={ closeOpen}>
                            <span aria-hidden={true}>×</span>
                          </button>
                        </div>
                        <div style = {{ marginLeft:"25px"}}>{ value?.message }</div>
                
                        <div className="modal-footer">
                        <Button color="success" type="button" onClick={()=>handleSave(value, 1)}>Approve</Button>
                        {/* <Button color="warning" type="button" onClick={()=>handleSave(value, 0)}>Decline</Button> */}
                        <Button color="warning" type="button" onClick={()=>handleSave(value, 2)}>No Deal</Button>
                        <Button color="info" type="button" onClick={()=>handleSave(value, 0)}>Still Under Discussion</Button>
                        <Button color="success" type="button" onClick={()=>handleSave(value, 5)}>Already Connected</Button>
                        {/* <Button color="secondary" data-dismiss="modal" type="button"  onClick={closeOpen}>Ask Me Later</Button> */}
                        </div></>
            }
            {value?.overallList  && value?.overallList.length > 1 &&
              <><div className="modal-header">
              <strong>Event Meeting Connection Request</strong> 
              <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={ closeOpen}>
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div style = {{ marginLeft:"25px"}}>
                <div>Can you please confirm that you have signed a partnership agreement with below companies who indicated a signed deal ? They have indicated the same from their end, and we need a confirmation from you</div>


                <div style={{width:"100%", display:"block", fontSize:"14px", padding:"10px"}}>
                  <div style={{width:"49%", display:"inline-block"}}>
                    <div><strong>Company Name  </strong> </div>
                    {/* <div><strong>Response Type : </strong>{updResponse[x.responseType]}</div> */}
                  </div>

                  <div style={{width:"30%", display:"inline-block", verticalAlign:"top"}}>
                    <div><strong>Requested By  </strong> </div>
                    {/* <div><strong>Response Type : </strong>{updResponse[x.responseType]}</div> */}
                  </div>
                  <div style={{width:"28%", float:"right",display:"inline-block"}}>

                   

                  
                 
                  </div>
                </div>

              {value?.overallList.map((x) => (
                
                <div style={{width:"100%", display:"block", fontSize:"14px", padding:"10px"}}>
                  <div style={{width:"49%", display:"inline-block"}}>
                    <div>{x.companyName}</div>
                    {/* <div><strong>Response Type : </strong>{updResponse[x.responseType]}</div> */}
                  </div>

                   <div style={{width:"30%", display:"inline-block", verticalAlign:"top"}}>
                    <div>{x.firstName}</div>
                    {/* <div><strong>Response Type : </strong>{updResponse[x.responseType]}</div> */}
                  </div>

                  <div style={{width:"13%", float:"right", display:"inline-block"}}>

                   <div style={{display:"inline-block" , float:"right", marginRight:"12px"}}  id={x.id+'approve'}> <i title=" click to approve the request" style={{fontSize:"20px", color:"green", cursor:"pointer"}} class="fa fa-check" onClick={()=>handleSave(x, 1)}></i> 
                   {/* <UncontrolledTooltip content='Delete video' target={x.id+'approve'} placement='bottom'>
                      click to approve the request
                  </UncontrolledTooltip> */}
                   </div>
                   

                  <div style={{display:"inline-block", float:"right", marginRight:"12px"}}  id={x.id+'denied'}>  <i class="fas fa-trash-alt" title=" click to denied the request" style={{fontSize:"20px", color:"red", cursor:"pointer", marginLeft:"17px"}}  onClick={()=>handleSave(x, 0)}></i>
                  {/* <UncontrolledTooltip content='Delete video' target={x.id+'denied'} placement='bottom'>
                      click to denied the request
                  </UncontrolledTooltip> */}
                   </div>
                 
                  </div>
                </div>
                
              ))
              }

            </div>
    
            <div className="modal-footer">
            {/* <Button color="success" type="button" onClick={()=>handleSave(value, 1)}>Approve</Button>
            <Button color="warning" type="button" onClick={()=>handleSave(value, 0)}>Decline</Button> */}
            <Button color="secondary" data-dismiss="modal" type="button"  onClick={closeOpen}>Ask Me Later</Button>
            </div></>
            }
        </Modal>
    </div>
  );
}

export default  EventResponseDialog;